import { Link } from 'react-router-dom';
import { Box, Button, Chip, Divider, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import Layout from '../Layout';
import GameTitle from '../Shared/GameTitle';

const NEW_GAME_URL = 'https://tord.panoscool.com/';

const Card = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  textAlign: 'center',
  borderRadius: theme.shape.borderRadius * 2,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.35)}`,
  background: `linear-gradient(160deg, ${alpha(theme.palette.primary.main, 0.14)} 0%, ${alpha(
    theme.palette.secondary.main,
    0.1,
  )} 100%)`,
  padding: theme.spacing(4, 3),

  '&::before': {
    content: '""',
    position: 'absolute',
    top: -120,
    left: '50%',
    width: 260,
    height: 260,
    transform: 'translateX(-50%)',
    borderRadius: '50%',
    background: alpha(theme.palette.primary.main, 0.25),
    filter: 'blur(70px)',
    pointerEvents: 'none',
  },
}));

const Content = styled(Box)({
  position: 'relative',
});

function UpgradeNotice() {
  return (
    <Layout>
      <GameTitle />

      <Card>
        <Content>
          <Chip
            color="primary"
            variant="outlined"
            size="small"
            icon={<AutoAwesomeIcon />}
            label="New version"
          />

          <Typography variant="h5" mt={2} fontWeight={700}>
            TorD has been upgraded
          </Typography>

          <Typography color="textSecondary" mt={1.5} mx="auto" maxWidth={420}>
            The game has a new home with a fresh look and a better experience. Come join the party
            over there — or continue to the classic version below if you prefer it.
          </Typography>

          <Button
            size="large"
            color="primary"
            variant="contained"
            href={NEW_GAME_URL}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<RocketLaunchIcon />}
            sx={{ mt: 3 }}
          >
            Play the new version
          </Button>

          <Typography variant="caption" color="textSecondary" display="block" mt={1}>
            tord.panoscool.com
          </Typography>
        </Content>
      </Card>

      <Divider sx={{ my: 3 }}>
        <Typography variant="caption" color="textSecondary">
          OR
        </Typography>
      </Divider>

      <Box textAlign="center" pb={2}>
        <Button
          color="secondary"
          variant="outlined"
          component={Link}
          to="/game"
          startIcon={<SportsEsportsIcon />}
        >
          Continue to the classic game
        </Button>
      </Box>
    </Layout>
  );
}

export default UpgradeNotice;
